import { Container, Grid, Typography, Box } from "@material-ui/core";
import { Pagination } from "@mui/material"; // Correct import
import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { PageBanner } from "../../components";
import BookKleverBookCard from "../../components/BookCard/BookKleverBookCard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { backend } from "../../api";
import { Skeleton } from "@material-ui/lab";

function KleverBook() {
  const [books, setBooks] = useState([]);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const booksPerPage = 12; // Number of books per page
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAllBooks();
  }, []);

  const fetchAllBooks = () => {
    backend
      .get("/adverbook")
      .then(({ data }) => {
        const kleverBooks = data.data.filter(
          (book) =>
            book?.addToKlever === true && book?.status[1]?.status === "approved"
        );
        console.log(kleverBooks);
        setBooks(kleverBooks);
      })
      .catch((err) => {
        if (err.response) {
          setError(err.response.data.message);
        } else {
          setError(err.message);
        }
      });
  };

  // Get current books
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = books.slice(indexOfFirstBook, indexOfLastBook);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <Fragment>
      <Helmet>
        <title>Shop - d2p</title>
      </Helmet>
      <ToastContainer />
      <PageBanner title="KleverBook" image="/assets/images/bg4.jpg" />
      <Container style={{ marginTop: "60px", marginBottom: "60px" }}>
        {currentBooks.length > 0 ? (
          <Grid container spacing={2}>
            {currentBooks.map((book, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <BookKleverBookCard
                  title={book.book_title}
                  //   price={book?.price?.digital_price}
                  cover={book.book_cover}
                  bookId={book._id}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box>
            {error ? (
              <Box textAlign="center">
                <Typography variant="subtitle2" color="error">
                  {error}
                </Typography>
              </Box>
            ) : (
              <Skeleton animation="wave" />
            )}
          </Box>
        )}
        {books.length > booksPerPage && (
          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={Math.ceil(books.length / booksPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              sx={{
                "& .MuiPaginationItem-root": {
                  "&:hover": {
                    backgroundColor: "#FECE00",
                  },
                },
                "& .Mui-selected": {
                  backgroundColor: "#FECE00",
                  color: "#000",
                },
                "& .MuiPaginationItem-ellipsis": {
                  color: "#FECE00",
                },
              }}
            />
          </Box>
        )}
      </Container>
    </Fragment>
  );
}

export default KleverBook;